import React, { useEffect, useState } from "react";
import { MainLayout, UpgradeCard } from "../../../components";
import { useSelector, connect } from "react-redux";
import { logout } from "../../../redux/actions/login";
import { handleMainTab } from "../../../redux/actions/free/homeActions";
import DashboardPage from "./dashboard";
import ROUTES from "../../constants/routes";
import { useNavigate } from "react-router-dom";
import { campaignsLimit } from "../../../services";
import authHeader from "../../../services/auth/auth-header";
import { getApi } from "../../../services/helpers/apiCall";

// get step data from redux main state
const authData = (state) => state.auth;
// get step data from redux main state
const data = (state) => state.dashboard;

function Dashboard(props) {
  const [campaigns, setCampaigns] = useState(0);
  const [openModal, setOpenModal] = React.useState(false);

  let client = useSelector(authData);
  let clientData = useSelector(data);

  let navigate = useNavigate();

  let { companyId } = client?.client;
  let createNewGame = async () => {
    let apiCallRequest = {
      url: `/companies/${companyId}`,
      data: null,
      config: {
        headers: authHeader(),
      },
    };

    getApi(apiCallRequest)
      .then((res) => {
        let bucketName = res.data.bucket_name;
        if (
          campaignsLimit[bucketName] &&
          campaignsLimit[bucketName].limit > campaigns
        ) {
          props.handleMainTab();
          navigate(`${ROUTES.HOME}`, { replace: true });
        } else {
          setOpenModal(true);
        }
      })
      .catch((err) => {
        console.log(err.message, "dashboard");
      });
  };

  // let { bucketName } = client;

  useEffect(() => {
    let campaigns = clientData && clientData.campaigns;
    if (campaigns && campaigns.length > 0) {
      setCampaigns(campaigns.length);
    }
  }, [clientData]);

  let onCloseUpgrade = () => {
    setOpenModal(!openModal);
  };

  return (
    <MainLayout
      showProgress={false}
      showDashboardButton={true}
      logout={props.logout}
      stepHandler={props.handleMainTab}
      onClick={() => createNewGame()}
    >
      <div className="flex 2xl:flex-row xl:flex-row lg:flex-row md:flex-row flex-col 2xl:justify-between xl:justify-between lg:justify-between md:justify-between items-center">
        <p></p>
        <div className="-mt-44">
          {openModal ? (
            <UpgradeCard type="FREE" onCloseUpgrade={onCloseUpgrade} />
          ) : null}
        </div>
      </div>
      <div className="bg-[#F5F6FA] h-max ">
        <DashboardPage />
      </div>
    </MainLayout>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  logout,
  handleMainTab,
})(Dashboard);
